export const FFA_CATEGORIES_IDS = [7, 3, 2, 4, 5]

export const FFA_ID = 13

export const ERROR_MESSAGES = {
  MAPS_LIMIT_EXCEEDED: 'Ten maps maximum',
  GAME_TYPES_LIMIT_EXCEEDED: 'Five game modes maximum',
  USER_ALREADY_ADDED: 'User has already been added to the list of admins',
}

export const TOURNAMENT_OWNER_AVATAR = '/forgehub_author.png'
